<script lang="ts" context="module">
  export const filterQuery = writable('');
</script>

<script lang="ts">
  import { Button } from '$lib/components/ui/button';

  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import { writable } from 'svelte/store';

  const dispatch = createEventDispatcher();
  let inputElement: HTMLInputElement;

  let timer: ReturnType<typeof setTimeout>;
  const debounce = (e: Event) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      filterQuery.set((e?.target as HTMLTextAreaElement).value);

      // also trigger an event to scroll the current race back into view
      if ((e?.target as HTMLTextAreaElement).value === '') {
        setTimeout(() => {
          dispatch('filterChange');
        }, 500);
      }
    }, 200);
  };
  onDestroy(() => {
    timer && clearTimeout(timer);
  });

  onMount(() => {
    // register a listener for ctrl/cmd + f
    window.addEventListener('keydown', (e) => {
      if (e.ctrlKey || e.metaKey) {
        if (e.key === 'k' || e.key === 'K') {
          e.preventDefault();
          inputElement.focus();
          // select all text
          inputElement.setSelectionRange(0, inputElement.value.length);
        }
      }
    });
  });
</script>

<div class="w-full">
  <label for="search" class="sr-only mb-2 text-sm font-medium text-gray-900"
    >Search</label
  >
  <div class="relative px-2">
    <div
      class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-5"
    >
      <svg
        aria-hidden="true"
        class="h-5 w-5 text-gray-500"
        fill="none"
        stroke={$filterQuery?.length > 0 ? 'purple' : 'currentColor'}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        ><path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        /></svg
      >
    </div>
    <input
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      bind:this={inputElement}
      type="search"
      id="search"
      on:input={debounce}
      class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2 pl-10 text-sm text-gray-900 focus:ring-purple-200
      {$filterQuery.length > 0
        ? 'border-1 border-purple-400 bg-purple-100'
        : ''}"
      placeholder="Search"
      required
    />
  </div>
</div>
